import { ReactElement } from 'react';
//
import { CLEAR_MODAL_CONTENT, SET_MODAL_CONTENT, TAction } from 'store/modal/types';

export function setModalContent(content: ReactElement): TAction {
  return {
    type: SET_MODAL_CONTENT,
    content,
  };
}

export function clearModalContent(): TAction {
  return {
    type: CLEAR_MODAL_CONTENT,
  };
}
